import React from "react";

export default function Terms() {
  return (
    <div className="pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Terms & Conditions
          </h1>
          <p className="text-xl text-gray-600">
            Last updated:{" "}
            {new Date().toLocaleDateString("en-GB", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
        </div>
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100">
          <div
            className="border-l-4 p-8 mb-12 rounded-r-2xl"
            style={{
              background: "linear-gradient(90deg,#f6fbf0,#eef7e5)",
              borderColor: "#93C754",
            }}
          >
            <div className="flex items-start">
              <div className="text-3xl mr-4">ℹ️</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Please read carefully
                </h3>
                <p className="text-gray-700">
                  Read carefully the following Terms and Conditions and if you
                  do not unconditionally agree to all of them, please avoid
                  immediately any use or attempt to use this website.
                </p>
              </div>
            </div>
          </div>
          <div className="prose prose-lg max-w-none space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center">
                <span
                  className="w-2 h-8 rounded mr-4"
                  style={{
                    backgroundImage: "linear-gradient(180deg,#93C754,#7FB740)",
                  }}
                ></span>
                1. Acceptance of Terms
              </h2>
              <div className="bg-gray-50 p-6 rounded-xl">
                <p className="text-gray-700">
                  By using this page, the visitor assumes that they accept the
                  terms and conditions outlined below.
                </p>
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center">
                <span
                  className="w-2 h-8 rounded mr-4"
                  style={{
                    backgroundImage: "linear-gradient(180deg,#93C754,#7FB740)",
                  }}
                ></span>
                2. Privacy and Protection of Personal Data
              </h2>
              <div className="bg-gray-50 p-6 rounded-xl">
                <p className="text-gray-700 mb-4">
                  We collect and process your personal data only when it is
                  absolutely necessary. We will never sell, rent, distribute, or
                  publicize in any way your personal data.
                </p>
                <p className="text-gray-700">
                  <strong>Important:</strong> If you are under 16, you MUST have
                  your parents' consent before using the services of this site.
                </p>
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center">
                <span
                  className="w-2 h-8 rounded mr-4"
                  style={{
                    backgroundImage: "linear-gradient(180deg,#93C754,#7FB740)",
                  }}
                ></span>
                3. Relevant Legislation
              </h2>
              <div className="bg-gray-50 p-6 rounded-xl">
                <p className="text-gray-700 mb-4">
                  This site is designed to comply with the following
                  laws/regulations regarding the protection of user's personal
                  data:
                </p>
                <ul className="text-gray-700 space-y-2">
                  <li>• EU Data Protection Directive (DPD of year 1995)</li>
                  <li>
                    • Regulation on general EU data protection (GDPR of year
                    2018)
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center">
                <span
                  className="w-2 h-8 rounded mr-4"
                  style={{
                    backgroundImage: "linear-gradient(180deg,#93C754,#7FB740)",
                  }}
                ></span>
                4. Personal Information Collected and Why
              </h2>
              <div className="bg-gray-50 p-6 rounded-xl space-y-4">
                <p className="text-gray-700 mb-4">
                  This site collects and uses personal information for the
                  following reasons:
                </p>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Website Traffic Monitoring
                  </h3>
                  <p className="text-gray-700">
                    Like most sites, this site uses Google Analytics (GA) to
                    track user activity. We use this data to determine the
                    number of our site visitors to better understand how they
                    find and use our web pages. Although GA records data such as
                    your geographic location, your device, your web browser, and
                    your operating system, none of this information identify you
                    to us. GA also records your computer's IP address, which
                    could be used to identify you, but Google does not provide
                    access to it. We believe that Google is a third data
                    processor that is compliant with the requirements of
                    European legislation.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Contact Forms and E-mail Links
                  </h3>
                  <p className="text-gray-700">
                    If you choose to contact us using a contact form or an email
                    link, none of the data you provide will be stored to our
                    site or transferred or processed by any third party data
                    processor. Instead, these data will be sent to us via an
                    SMTP protocol (Simple Mail Transfer Protocol). Our SMTP
                    servers are protected by a TLS security protocol (also known
                    as SSL), meaning that email content is encrypted before
                    being sent over the Internet. The content of the email is
                    decrypted by our local computers and devices.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center">
                <span
                  className="w-2 h-8 rounded mr-4"
                  style={{
                    backgroundImage: "linear-gradient(180deg,#93C754,#7FB740)",
                  }}
                ></span>
                5. Cookies and How to Manage Them
              </h2>
              <div className="bg-gray-50 p-6 rounded-xl space-y-4">
                <p className="text-gray-700 mb-4">
                  On this site, we use cookies to improve your user experience.
                  Site functionality will be significantly affected if you
                  disable or disagree with the use of cookies. If you need any
                  help on how to manage certain types of cookies, including how
                  to check or delete them, please visit:{" "}
                  <a
                    href="https://www.aboutcookies.org"
                    className="text-[#7FB740] underline"
                    target="_blank"
                    rel="noreferrer"
                  >
                    www.aboutcookies.org
                  </a>
                </p>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Google Analytics Cookies
                  </h3>
                  <p className="text-gray-700 mb-3">
                    Google Analytics cookies are performance analytics/logging
                    cookies that allow us to collect anonymous information about
                    how visitors use our site. These cookies can inform us on
                    how many visitors use the site, the visit's time and
                    duration, and also provide information on how visitors
                    navigate across the site. This information helps us improve
                    the way our site works. They are anonymous information and
                    do not contain personal information.
                  </p>
                  <p className="text-gray-700 mb-3">
                    The information collected by the Google Analytics cookies
                    about our site is transferred and stored on Google's servers
                    in accordance with Google's privacy policy.
                  </p>
                  <p className="text-gray-700">
                    For more information on Google Analytics, please visit{" "}
                    <a
                      href="https://support.google.com/analytics"
                      className="text-[#7FB740] underline"
                      target="_blank"
                      rel="noreferrer"
                    >
                      support.google.com
                    </a>
                    . You can disable Google Analytics tracking by visiting{" "}
                    <a
                      href="https://tools.google.com/dlpage/gaoptout"
                      className="text-[#7FB740] underline"
                      target="_blank"
                      rel="noreferrer"
                    >
                      tools.google.com
                    </a>
                    .
                  </p>
                  <p className="text-gray-600 text-sm mt-2 italic">
                    If you disable these cookies, your activity will not be
                    counted or used in the statistics we collect to improve the
                    services we provide through this site. Website functionality
                    will not be affected.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Video Providers Cookies
                  </h3>
                  <p className="text-gray-700">
                    Video providers can place cookies on your device if you
                    watch their video on our site. If you disable these cookies
                    you may not be able to see the embedded videos on our site.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Social Networks Cookies
                  </h3>
                  <p className="text-gray-700">
                    Third-party social networks can place cookies on your device
                    if you choose to share a web page of our site with another
                    third-party Social Network site, by clicking on one of the
                    «share» buttons. If you disable these cookies, you will not
                    be able to share any of our content with third-party social
                    networks.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center">
                <span
                  className="w-2 h-8 rounded mr-4"
                  style={{
                    backgroundImage: "linear-gradient(180deg,#93C754,#7FB740)",
                  }}
                ></span>
                6. Web Server Security
              </h2>
              <div className="bg-gray-50 p-6 rounded-xl">
                <p className="text-gray-700">
                  All web traffic (file transfer) between this site and your
                  browser is encrypted and transferred via the HTTPS protocol
                  using Secure Sockets Layer (SSL).
                </p>
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center">
                <span
                  className="w-2 h-8 rounded mr-4"
                  style={{
                    backgroundImage: "linear-gradient(180deg,#93C754,#7FB740)",
                  }}
                ></span>
                7. Data Breaches
              </h2>
              <div className="bg-gray-50 p-6 rounded-xl">
                <p className="text-gray-700 mb-4">
                  For any of your personal information stored in our database,
                  all necessary action will be taken to be secure as possible.
                </p>
                <p className="text-gray-700">
                  We will report any unlawful violation of our database or any
                  third party data processing database to all relevant
                  stakeholders as well as authorities within 72 hours of the
                  violation, if it is obvious that the personal data stored in
                  recognizable form, have been stolen.
                </p>
              </div>
            </div>
            <div
              className="p-8 rounded-2xl border"
              style={{
                background: "linear-gradient(90deg,#f6fbf0,#eef7e5)",
                borderColor: "#93C754",
              }}
            >
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                📧 Contact Information
              </h2>
              <div className="space-y-4">
                <p className="text-gray-700 text-lg">
                  For any questions regarding these Terms & Conditions, please
                  contact us at:{" "}
                  <a
                    href="mailto:info@trlab.eu"
                    className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors"
                  >
                    info@trlab.eu
                  </a>
                </p>
                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-2">
                    Company Details:
                  </h3>
                  <div className="text-gray-700 text-sm space-y-1">
                    <p>
                      <strong>Theophrastus Research Lab</strong>
                    </p>
                    <p>Mytilene, Lesvos Island</p>
                    <p>North Aegean, Greece</p>
                    <p>
                      Email:{" "}
                      <a
                        href="mailto:info@trlab.eu"
                        className="text-emerald-600 hover:text-emerald-700"
                      >
                        info@trlab.eu
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
